export function siteStatus (prop, t$) {
  let objStatus = ''
  if (prop.cdn) {
    const icons = {
      true: '$symbols-circle-check-filled'
    }

    const color = {
      true: 'success'
    }

    const status = {
      true: true,
      false: false
    }

    objStatus = {
      value: t$.statusCdn[prop.cdn],
      color: color[prop.cdn],
      status: status[prop.cdn],
      icons: icons[prop.cdn]
    }
  } else {
    const icons = {
      active: '$symbols-circle-check-filled',
      activating: '$symbols-circle-plus-filled',
      deactivated: '$brand-locaweb-filled',
      deleting: '$brand-locaweb-filled'
    }

    const color = {
      active: 'success',
      activating: 'gray',
      deactivated: 'gray',
      deleting: 'gray'
    }

    const status = {
      active: 'active',
      activating: 'activating',
      deactivated: 'deactivated',
      deleting: 'deleting'
    }

    objStatus = {
      value: t$.status[prop.status],
      color: color[prop.status],
      status: status[prop.status],
      icons: icons[prop.status]
    }
  }

  return objStatus
}
